export default __webpack_public_path__ + "static/media/defaultLogo.c85d50d5.png";